import { render, staticRenderFns } from "./PessoaBusca.vue?vue&type=template&id=04d23ffe"
import script from "./PessoaBusca.vue?vue&type=script&lang=js"
export * from "./PessoaBusca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports